import React, { useEffect } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams} from 'react-router-dom'

import { faSave, faRemove } from '@fortawesome/free-solid-svg-icons'

import BreadcrumbComponent from '@component/Breadcrumb'
import ButtonComponent from '@component/Form/Button'
import DataTableComponent from '@component/Datatable'
import DropdownComponent from '@component/Dropdown'
import InputComponent from '@component/Form/Input'
import TextareaComponent from '@component/Form/Textarea'
import SwitchComponent from '@component/Form/Switch'

import { OmbudsmanTypeService } from '@service/ombudsman/types'

import Swal from 'sweetalert2'


const breadcrumbItems = [
    { title: 'Dashboard', url: '/dashboard' },
    { title: 'Ouvidoria', url: '/ombudsman/manifestations' },
    { title: 'Tipos de Manifestações' }
]


export default function OmbudsmanTypes() {

    const navigate = useNavigate();

    const { type_id } = useParams();

    const { 
        control, 
        formState: { errors }, 
        handleSubmit, 
        register,
        setValue,
        reset
    } = useForm({ mode: 'onChange' })


    const fetchTypeEdit = async () => {
        await OmbudsmanTypeService.show(type_id)
            .then(response => {
                setValue('title', response.data[0].title)
                setValue('description', response.data[0].description)
                setValue('status', response.data[0].status)
            })
    }


    const onSubmit = async (data, e) => {
        e.preventDefault();
        
        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            imageUrl: '/assets/images/loading.gif',
            imageWidth: 100,
            imageHeight: 100,
            text: 'Processando, aguarde...',
            showConfirmButton: false,
            width: 300,
        });

        if (type_id) {

            await OmbudsmanTypeService.update(data, type_id)
                .then(response => {
                
                    Swal.close();
                    Swal.fire({
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                        icon: 'success',
                        text: response.data.message,
                    }).then(() => reset());

                })
                .catch(error => { 
                    Swal.close();
                    Swal.fire({
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                        icon: 'error',
                        text: error.response.data.message
                    });
                });

        } else {

            await OmbudsmanTypeService.store(data)
                .then(response => {
                                
                    Swal.close();
                    Swal.fire({
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                        icon: 'success',
                        text: response.data.message,
                    }).then(() => reset());

                })
                .catch(error => { 
                    Swal.close();
                    Swal.fire({
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                        icon: 'error',
                        text: error.response.data.message
                    });
                });

        }
    }
    
    
    const dropdown = (type_id) => {
        let content = [
            {titulo: 'Editar', parametro: {url: `/ombudsman/types/${type_id}`}},
            {titulo: 'Apagar', parametro: {onclick: 'excluir', item: {'type_id' : type_id }}}
        ];

        return <DropdownComponent function={dropdownAction} content={content} />
    }


    const dropdownAction = (parametro) => {
        if (!parametro.hasOwnProperty('onclick')) {
            navigate(parametro.url)
        } else eval(parametro.onclick)(parametro.item)
    }


    const excluir = (item) => {
        console.log(item)

    }
    
    
    const columns = [
        {
            cell: (row) => (
                row.title ? row.title : '-'
            ),
            center: true,
            name: 'Título',
            selector: 'title',
            sortable: true,
            width: '15%'
        }, {
            cell: (row) => (
                row.description ? row.description : '-'
            ),
            center: true,
            name: 'Descrição',
            selector: 'description',
            sortable: true,
            width: '60%'
        },
        {
            cell: (row) => {
                return (row.status) ? (
                    <span className='badge bg-success'>Liberado</span>
                ) : (<span className='badge bg-danger'>Bloqueado</span>)
            },
            center: true,
            name: 'Situação',
            selector: 'status',
            sortable: true,
            width: '15%'
        },
        {
            cell: (row) => ( dropdown(row.id) ),
            center: true,
            name: 'Ações',
            sortable: false,
            width: '10%'
        }
    ]


    useEffect(() => {
        if (type_id) {
            fetchTypeEdit()
        }
    }, [type_id])


    return (

        <>
        
            <div className='header' id='customer_form'>
                <h1 className='header-title'>Tipo de Manifestação</h1>
                <BreadcrumbComponent breadcrumb={breadcrumbItems} />
            </div>
            
            <Row className='mb-3'>
                <Col lg={8}>
                    <Card>
                        <Card.Body>
                            <DataTableComponent
                                columns={columns}
                                url={'/ombudsman-types'}
                                title=''
                                pagination={true}
                                subHeader={true}
                                expandable={false}
                                expandableData=''
                                selectableRows={false}
                                selectableRowsNoSelectAll={false}
                            />
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4}>
                    <Form 
                        autoComplete='off'
                        onSubmit={handleSubmit(onSubmit)}>

                        <Card>
                            <Card.Header>
                                <h4>{(type_id) ? `Editar tipo de manifestação - #${type_id}` : 'Cadastrar novo tipo de manifestação' }</h4>
                            </Card.Header>

                            <Card.Body>

                                <Row>
                                    <Col lg={12}>
                                        <InputComponent
                                            control={control}
                                            errors={errors}
                                            label='Título'
                                            name='title'
                                            placeholder='Informe o título' 
                                            type='text'
                                            register={register}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={12}>
                                        <TextareaComponent
                                            control={control}
                                            errors={errors}
                                            label='Descrição'
                                            name='description'
                                            placeholder='Informe a descrição'
                                            required={false}
                                            register={register}
                                            rows={4}
                                        />
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <Col lg={6}>
                                        <SwitchComponent
                                            control={control}
                                            errors={errors}
                                            checked={true}
                                            label='Situacao'
                                            name='status'
                                            required={false}
                                            register={register}
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col lg={6}>
                                        <ButtonComponent
                                            variant='danger'
                                            icon={faRemove}
                                            id='btn-cancel'
                                            title='Cancelar'
                                            type='button'
                                            onClick={() => navigate('/ombudsman/types')}
                                        />
                                    </Col>

                                    <Col lg={6} className='text-end'>
                                        <ButtonComponent
                                            variant='success'
                                            icon={faSave}
                                            id='btn-save'
                                            title='Gravar'
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                            
                    </Form>
                </Col>
            </Row>

        </>

    )
}
                            